/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Group_Media_PlayerInputs */

const en_shortcut_keys_group_media_player = /** @type {(inputs: Shortcut_Keys_Group_Media_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Player`)
};

const fr_shortcut_keys_group_media_player = /** @type {(inputs: Shortcut_Keys_Group_Media_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecteur media`)
};

const de_shortcut_keys_group_media_player = /** @type {(inputs: Shortcut_Keys_Group_Media_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienplayer`)
};

const it_shortcut_keys_group_media_player = /** @type {(inputs: Shortcut_Keys_Group_Media_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettore multimediale`)
};

const ru_shortcut_keys_group_media_player = /** @type {(inputs: Shortcut_Keys_Group_Media_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медиаплеер`)
};

const es_shortcut_keys_group_media_player = /** @type {(inputs: Shortcut_Keys_Group_Media_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproductor multimedia`)
};

const zh_cn2_shortcut_keys_group_media_player = /** @type {(inputs: Shortcut_Keys_Group_Media_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体播放器`)
};

const ja_shortcut_keys_group_media_player = /** @type {(inputs: Shortcut_Keys_Group_Media_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアプレーヤー`)
};

const hi_shortcut_keys_group_media_player = /** @type {(inputs: Shortcut_Keys_Group_Media_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया प्लेयर`)
};

const pt_pt2_shortcut_keys_group_media_player = /** @type {(inputs: Shortcut_Keys_Group_Media_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprodutor de mídia`)
};

/**
* | output |
* | --- |
* | "Media Player" |
*
* @param {Shortcut_Keys_Group_Media_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_group_media_player = /** @type {((inputs?: Shortcut_Keys_Group_Media_PlayerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Group_Media_PlayerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_group_media_player(inputs)
	if (locale === "de") return de_shortcut_keys_group_media_player(inputs)
	if (locale === "it") return it_shortcut_keys_group_media_player(inputs)
	if (locale === "ru") return ru_shortcut_keys_group_media_player(inputs)
	if (locale === "es") return es_shortcut_keys_group_media_player(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_group_media_player(inputs)
	if (locale === "ja") return ja_shortcut_keys_group_media_player(inputs)
	if (locale === "hi") return hi_shortcut_keys_group_media_player(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_group_media_player(inputs)
	return en_shortcut_keys_group_media_player(inputs)
});